/* Rôles de l'API → libellés français (les valeurs inconnues sont laissées telles quelles). */
const ROLE_LABELS_FR = {
  superadmin: 'Super administrateur',
  super_admin: 'Super administrateur',
  admin: 'Administrateur',
  user: 'Utilisateur',
};

const roleLabelFr = (role) => {
  if (!role) return '';
  return ROLE_LABELS_FR[String(role).toLowerCase()] || role;
};

/**
 * Exporte une liste d'utilisateurs au format CSV.
 * @param {Array}  users - Liste des utilisateurs à exporter (déjà filtrée)
 * @param {string} name  - Nom du fichier, avec ou sans ".csv". À construire
 *                         avec buildExportName() pour suivre le standard
 *                         sfa-<date>-<section>-<filtres>.
 *
 * Le fichier est toujours généré, même si la liste est vide.
 */
export const exportUsersToCSV = (users, name) => {
  const safeUsers = Array.isArray(users) ? users : [];

  const now = new Date();
  const exportDateTime = now.toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const exportDate = now.toLocaleDateString('fr-FR').replace(/\//g, '-');

  const headers = [
    'Identifiant', "Nom d'utilisateur", 'Email', 'Nom', 'Prénom', 'Rôle',
    'Organisation', 'Adresse', 'Pays', 'Ville', 'Statut',
  ];

  const escapeCell = (cell) => {
    const s = String(cell ?? '');
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };

  const rows = safeUsers.map((user) => [
    user.id           || '',
    user.username     || '',
    user.email        || '',
    user.name         || '',
    user.lastname     || '',
    roleLabelFr(user.role),
    user.organization || '',
    user.adress       || '',
    user.country      || '',
    user.city         || '',
    user.active ? 'Actif' : 'Inactif',
  ]);

  const csvContent = [
    `Date d'export :,${exportDateTime}`,
    '',
    headers.join(','),
    ...rows.map((row) => row.map(escapeCell).join(',')),
  ].join('\n');

  const baseName = name || `utilisateurs-${exportDate}`;
  const fileName = baseName.toLowerCase().endsWith('.csv') ? baseName : `${baseName}.csv`;

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};